var map = {
	"./img_1.jpg": 84295,
	"./img_2.jpg": 25722,
	"./img_3.jpg": 93125,
	"./img_4.jpg": 96248,
	"./img_5.jpg": 91255,
	"./img_6.jpg": 48630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24222;